<div class="wrapper-md">
    <app-breadcrumbs [items]="[
                     { url: '/employee-applications', text: 'employeeApplications_title' },
					 { text: 'employeeApplication_title' }
					 ]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{title}}</h1>
        <aside *ngIf="canPickEmployee && isReady && !isPersonPickerOpened">
            <button type="button" class="btn btn-outline" (click)="togglePersonPicker()">
                <i class="fi fi-rs-user"></i>
                {{'employeeApplication_btnPickEmployee' | translate}}
            </button>
        </aside>
    </header>

    <div class="content-desc" *ngIf="description" [innerHTML]="description | safeHtml"></div>

    <app-alert level="danger" *ngIf="isDenied && !isPersonPickerOpened">{{'eServiceNotAvailable' | translate}}</app-alert>

    <app-person-picker *ngIf="isPersonPickerOpened" [personType]="'employee'" (pick)="pickPerson($event)"></app-person-picker>

    <ng-container *ngIf="!isPersonPickerOpened && isReady">
        <div class="form-field required" *ngIf="employeeData?.length >= 1 && !finished">
            <label class="form-label">{{'employeeApplication_lblStructure' | translate}}</label>
        <app-select [(ngModel)]="selectedEmployee"
                    name="selectedEmployee"
                    [required]="true"
                    [disabled]="employeeData.length < 2"
                    [options]="employeeData"
                    [displayFn]="employeeOptionDisplayFn">
        </app-select>
    </div>

        <ng-container *ngIf="type && selectedEmployee">
            <app-custom-employee-application #appForm
                                             [type]="type"
                                             [employee]="selectedEmployee"
                                             (init)="onFormInit($event)"
                                             (done)="onFormDone()"></app-custom-employee-application>
        </ng-container>
    </ng-container>
</div>
